import { setSnackbarMessage } from 'actions/snackbar';
import client from 'core/axios';

const reportBlockedVideo = url => async dispatch => {
  try {
    const { status } = await client.post(`v1/common/report-error`, {
      errorType: 'BLOCKED_CONTENT',
      errorContext: {
        url,
      },
    });
    if (status === 200) {
      dispatch(
        setSnackbarMessage({
          message: `Thanks! We've notified someone at your district`,
        }),
      );
    }
  } catch (err) {
    console.warn('There was a problem reporting this video', err);
  }
};

export default reportBlockedVideo;
